import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const depositAddressApi = createApi({
  reducerPath: 'depositAddressApi',
  tagTypes: ['DepositAddress', 'Assets', 'Networks'],
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('token');
      if (token) {
        headers.set('X-Token', token);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAssets: builder.query({
      query: () => '/admin/assets',
      providesTags: ['Assets'],
    }),
    getNetworks: builder.query({
      query: (assetCode) => `/admin/crypto/networks?asset_code=${assetCode}`,
      providesTags: ['Networks'],
    }),
    getDepositAddress: builder.query({
      query: ({ user_id, asset_code, network }) => {
        let url = `/admin/crypto/deposit_address?user_id=${user_id}&asset_code=${asset_code}`;
        if (network) {
          url += `&network=${network}`;
        }
        return url;
      },
      providesTags: ['DepositAddress'],
    }),
  }),
});

export const {
  useGetAssetsQuery,
  useGetNetworksQuery,
  useLazyGetDepositAddressQuery,
} = depositAddressApi;